module.exports = __webpack_public_path__ + "static/img/join.34412f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/join.svg
// module id = RKaW
// module chunks = 0